import { createComponent } from '@lit/react';
import * as React from 'react';
import {
  GenerateComponentTypeWithChildren,
  GeneratePropsWithRef,
} from '../../components/component-types-generics';
import { UniversalUserDropdownWC } from './universal-user-dropdown.wc';

export type UniversalUserDropdownProps =
  GenerateComponentTypeWithChildren<UniversalUserDropdownWC> & {
    onLogout?: () => void;
    onPreferencesClick?: () => void;
  };

export type UniversalUserDropdownPropsWithRef =
  GeneratePropsWithRef<UniversalUserDropdownProps>;

export const UniversalUserDropdown = createComponent({
  tagName: UniversalUserDropdownWC.tagname,
  elementClass: UniversalUserDropdownWC,
  events: {
    onLogout: 'logout',
    onPreferencesClick: 'preferences-click',
  },
  react: React,
}) as UniversalUserDropdownPropsWithRef;
